import moduleTemplate from './moduleTemplate'
import ioParametersAPI from '@/api/ioParameters'

export default moduleTemplate(ioParametersAPI)
